import React from 'react'

import Icon from '../icon'

import * as S from './styles'

import IProps from './props'

const HomeSection = ({
  title, link, showLink = true, children,
}: IProps) => (
  <S.Section>
    <S.SectionHeader>
      <S.SectionTitle>{title}</S.SectionTitle>
      <S.SectionLink to={link} style={{ display: showLink ? 'flex' : 'none' }}>
        Ver tudo
        {' '}
        <Icon name="arrow-right" />
      </S.SectionLink>
    </S.SectionHeader>
    <S.SectionContent>{children}</S.SectionContent>
  </S.Section>
)

export default HomeSection
